/*
 * ニュース一覧取得(api get list)
 */
import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_LIST_RELEASE = 'API_GET_LIST_RELEASE';
/**
 * ニュース一覧の取得
 */
export const apiGetListRelease = ({ query }, meta) => apiGetList(API_GET_LIST_RELEASE, '/proffit_news', query, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
